import request from "@/axios/index";
// 列表
export function initListCodeEvent(id, params) {
    return request({
        url: "/list-code-event/"+ id,
        method: "get",
        params: params
    })
}

// 保存
export function saveListCodeEvent(data) {
    return request({
        url: '/list-code-event',
        method: 'post',
        data
    })
}

// 删除
export function delListCodeEvent(params) {
    return request({
        url: '/list-code-event/'+ params,
        method: 'delete',
    })
}

// sql动态查询
export function dynamicQuery(data) {
    return request({
        url: '/list-code-sql/dynamic-query',
        method: 'post',
        data
    })
}

// sql配置列表
export function initListCodeSql(id, params) {
    return request({
        url: "/list-code-sql/"+ id,
        method: "get",
        params: params
    })
}

// 保存
export function saveListCodeSql(data) {
    return request({
        url: '/list-code-sql',
        method: 'post',
        data
    })
}

// 删除
export function delListCodeSql(params) {
    return request({
        url: '/list-code-sql/'+ params,
        method: 'delete',
    })
}